export type AttachmentPanel = "uploader" | "restored" | "hidden";

/**
 * Which panel the fleet-message upload area shows.
 *
 * A server error replaces the panel, as it did before WEB-2272. An attachment that survived a trip to the driver
 * table is already uploaded, so it shows as restored rather than remounting the uploader over it, which would reopen
 * the file chooser. Everything else — a fresh open, an upload made during this mount, a restored attachment the
 * sender removed to replace — gets the uploader.
 */
export function attachmentPanel(input: {
  contentId: string | null;
  restoredContentId: string | null;
  hasServerError: boolean;
}): AttachmentPanel {
  if (input.hasServerError) return "hidden";
  if (input.restoredContentId !== null && input.contentId === input.restoredContentId) return "restored";
  return "uploader";
}
